
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "id": "图层_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "x": "0px",
    "y": "0px",
    "viewBox": "0 0 200 200",
    "style": "enable-background:new 0 0 200 200;",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "class": "st0",
        "d": "M150.1,159.6V47.7h11.8v122.8H55.4c-9.5,0-17.2-10-17.2-19.5V47.7c0-9.5,7.7-17.2,17.2-17.2h86.1v103.3H62.7\n\tc-7.1,0-12.5,5.8-12.5,12.9c0,7.1,5.4,12.9,12.5,12.9H150.1z M59.7,121.8h69.8V42.5H55.4c-2.8,0-5.2,2.4-5.2,5.2v76\n\tC53.1,122.5,56.3,121.8,59.7,121.8z M62.7,141.5h78.8v10.8H62.7h0.9h-0.9c-2.3,0-4.1-2.4-4.1-5.4c0-3,2.8-5.4,5.1-5.4H62.7z"
      }
    }
  ]
})
    }
  